import React from 'react';
import './Clampingstable.css'; // CSS नीचे दी गई है
import clampImage from '../../../imgs/Stable.webp'; // अपनी इमेज का सही path लगाएं

const Clampingstable = () => {
  return (
    <div className="stable-wrapper">
      <h1 className="new-systems-heading">NEW SYSTEMS</h1>

      <div className="stable-container">
        <div className="stable-text">
          <h2>CLAMPING SYSTEM</h2>
          <h3>-Stable & Durable</h3>
          <p>
            Brand new 3-platen stable design, which will optimize the stress
            distribution and has higher rigidity and more stable performance,
            meeting the demand of rapid mechanical movement.
          </p>
        </div>
        <div className="stable-image">
          <img src={clampImage} alt="Clamping System" />
        </div>
      </div>
    </div>
  );
};

export default Clampingstable;
